/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StartingMissionEditorType {
    Contact = 1,
    Function = 2,
}
